
import React, { Component } from "react";
import "./app.scss";

import Routes from '../routes/routes';

class App extends Component {
  render() {
    return (
      <Routes />
    );
  }
}

export default App;